// React
import { ChangeEvent } from 'react'

// Antd
import { Input } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'

// i18n
import { useTranslation } from 'react-i18next'

// Interfaces
import { IFormTextFieldProps } from './interfaces'

// Lodash
import omit from 'lodash/omit'

// Utils
import { commonUtils_phoneNumber } from 'utils/common/common.utils'

const FormTextField = ({ ...props }: IFormTextFieldProps) => {
  // Hook
  const { t } = useTranslation()

  /**
   * @description Watch any change in input
   *
   * @param {ChangeEvent<HTMLInputElement>} event
   *
   * @return {void} void
   */
  const onChangeText = (event: ChangeEvent<HTMLInputElement>) => {
    // Check if user is using text field for code
    if (props.isCode) event.target.value = event.target.value.toUpperCase()

    // Check if input is email
    if (props.isEmail) event.target.value = event.target.value.toLowerCase().replace(/\s+/, '')

    // Check if input is phone number
    if (props.isPhoneNumber) event.target.value = commonUtils_phoneNumber(event.target.value || '')

    props.onChange && props.onChange(event)
  }

  return (
    <>
      <Input
        {...omit(props, ['renderLabel', 'labelValue', 'onlyLabel', 'isCode', 'isEmail', 'isPhoneNumber', 'loading', 'noPrefix'])}
        placeholder={t(props?.placeholder || '')}
        className={`custom-input common ${props.className ? props.className : ''}`}
        onChange={onChangeText}
        prefix={props?.isPhoneNumber && !props?.noPrefix ? '+62' : undefined}
        suffix={props?.loading ? <LoadingOutlined /> : props?.suffix ? props?.suffix : undefined}
      />

      {props?.style?.display === 'none' ? (
        <div className="flex items-center">
          <p className="font-14 text-grey font-weight-400">{props?.labelValue || '-'}</p>
          {props?.renderLabel && props?.labelValue ? props.renderLabel : ''}
        </div>
      ) : (
        <></>
      )}
    </>
  )
}

export { FormTextField }
